import apiClient from "./api";
const CONVENIO_API_BASE_URL = "/convenios";
class ConveniosService {
  getConvenios() {
    return apiClient.get(CONVENIO_API_BASE_URL);
  }
  agregarConvenio(convenio) {
    return apiClient.post(CONVENIO_API_BASE_URL, convenio);
  }
  updateConvenio(convenio, convenioId) {
    return apiClient.put(CONVENIO_API_BASE_URL + "/" + convenioId, convenio);
  }
  deleteConvenio(convenioId) {
    return apiClient.delete(CONVENIO_API_BASE_URL + "/" + convenioId);
  }

  async getContactos(convenioId) {
    try {
      const response = await apiClient.get(`${CONVENIO_API_BASE_URL}/contactos/${convenioId}`,);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async validarCompania(nombre) {
    try {
      const response = await apiClient.post(`${CONVENIO_API_BASE_URL}/validar`, { nombre });
      const compania = response.data;
      return compania;
    } catch (error) {
      console.error(error);
    }
  }

  async buscarConvenios(busqueda) {
    try {
      const response = await apiClient.post(`${CONVENIO_API_BASE_URL}/buscar`, { busqueda });
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async getConvenioPorId(convenioId) {
    try {
      const response = await apiClient.get(
        `${CONVENIO_API_BASE_URL}/${convenioId}`,
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
}

export default new ConveniosService();